import { render, staticRenderFns } from "./FilterTickets.vue?vue&type=template&id=b1c84584&"
import script from "./FilterTickets.vue?vue&type=script&lang=js&"
export * from "./FilterTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports